/**
 * Dashboard API Service
 * 
 * This module handles all dashboard-related API calls
 * including statistics, analytics, and overview data.
 */

import axios from 'axios';
import API_CONFIG, { getAuthHeaders } from './config';

const dashboardAPI = {
  /**
   * Get dashboard statistics
   * @param {string} token - JWT access token
   * @returns {Promise<Object>} Dashboard statistics
   */
  async getStats(token) {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/api/dashboard/stats`, {
      headers: getAuthHeaders(token),
      timeout: API_CONFIG.TIMEOUT
    });
    return response.data;
  }
};

export { dashboardAPI };
